import React from 'react';
import { ExitingPersistence, type ExitingPersistenceProps } from '@atlaskit/motion';

export type RightSidebarTransitionProps = Pick<ExitingPersistenceProps, 'children'>;

export const RightSidebarTransition = ({ children }: RightSidebarTransitionProps) => (
	<ExitingPersistence appear>{children}</ExitingPersistence>
);
